import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../../common/sharedComponents/BottomSheet';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ExpandableCard } from '../../../myAudit/components/ExpandableCard';
import {
  deleteMyAuditRequest,
  getMyAuditList,
} from '../../../../requests/myAudit';
import { Sort } from '../../../common/sharedComponents/Sort';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Filter } from '../../../@types/sort';
import { Modal } from '../../../common/sharedComponents/Modal';
import { Button } from '../../../common/sharedComponents/Button';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../../../style/main.scss';
import { Headline3, Body5, Body3, Body4 } from '../../../common/typography';
import { FilterTypes, IMyAuditList } from '../../../@types/myAuditForm';
import {
  ContentContainer,
  DepartmentHeaderContainer,
  ButtonContainer,
  AuditorContainer,
  AuditorContent,
  AuditorSectionContainer,
  DeleteTitleContainer,
  FilterModalHeaderContainer,
  BottomSheetButtonSpacing,
  PaddingBottomM,
  PaddingBottomL,
  PaddingBottomS,
  StatusRadioReceivedWrapper,
  StatusRadioCreatedByWrapper,
  StatusRadioAssessedWrapper,
  InputContainer,
  CalendarIconContainer,
  MyAuditDatePickerContainer,
  CardContentWrapper,
  NoResultContainer,
  NoDataMessageContainer,
  SearchFieldInput,
  DisabledSearchBoxContainer,
  IconContainer,
  MyAuditListContainer,
  CreateNewMyAuditButtonContainer,
} from './styled.myAuditList';
import { useLocation } from 'react-router-dom';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DropdownSingle } from '../../../common/sharedComponents/DropdownSingle';
import { IDropdownOption } from '../../../@types/dropdown';
import { FilterIcon } from '../../../common/icons/FilterIcon';
import { IconButton } from '../../../common/sharedComponents/IconButton';
import { showErrorMessage } from '../../../../helpers/showMessage';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../../common/sharedComponents/buttons/ButtonLarge';
import { MyAuditSkeleton } from '../../MyAuditSkeleton/ListSkeleton';
import { DateFormatEnum, formatDate } from '../../../../helpers/dates';
import { getItem, removeItem, setItem } from '../../../../utils/localStorage';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar } from '../../../common/icons/Calendar';
import { SearchBoxContainsUsers } from './SearchBoxContainsUsers';
import { SearchBoxTemplate } from './SearchBoxTemplate';
import {
  ISelectedOption,
  IContainsSelectedOption,
} from './../../../@types/searchBox';
import { CloseCircleDark } from '../../../common/icons/CloseCircleDark';
import { SearchFile } from '../../../common/icons/SearchFile';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';
import {
  FilterContainer,
  FiltersContent,
  HeaderContainer,
  StyledMyAuditContainer,
} from '../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { IGetMyAuditList } from '../../../@types/myAudit';
import { SearchIcon } from '../../../common/icons/SearchIcon';
import moment from 'moment';
import { Nullable } from '../../../@types/genericTypes';
import {
  getBrandAndHotelData,
  userHotelDetails,
} from '../../../../helpers/handleBrandAndHotelData';
import {
  getInitialHotelSelectionData,
  updateHotelSelection,
} from '../../../../helpers/hotelSelectorHelpers';
import { LineHeader } from '../MyAuditChecklist/MyAuditChecklist.styled';
import { SubHeaderSelector } from '../../../../app/common/sharedComponents/SubHeaderSelector';
import { IListSelector } from '../../../../app/@types/subHeaderSelector';
import { DatePickerWrapper } from '../../../../app/common/sharedStyledComponents/Datepicker.styled';
import { RadioButton } from '../../../common/sharedComponents/RadioButton';
import { UserTypeEnum } from '../../../common/enum/generic';
import { INotificationHotelData } from '../../../@types/switchHotelModal';
import { SetDefaultTemplateId } from '../../../../components/commons/Header/SetDefaultTemplateId';
import { SwitchHotelModal } from '../../../common/sharedComponents/SwitchHotelModal';
import {
  MYLQA_ANALYTICS_EVENTS,
  useTrackMyLqaPageView,
} from '../../../../utils/myLqaAnalytics';

export function MyAuditList () {
  const hasTagged = false;
  type FilterTypesParams = 'received' | 'sent';
  const filteredTypes: { [key: string]: FilterTypes } = {
    received: 'receivedBy',
    sent: 'createdBy',
    tagged: 'tagged',
  };
  const { user } = getItem('user');
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const listType = searchParams.get('filterBy');
  const { t } = useTranslation();
  const location: any = useLocation();
  useTrackMyLqaPageView(MYLQA_ANALYTICS_EVENTS.MYAUDIT_PAGE_VIEWED);
  const [myAuditId, setMyAuditId] = useState(searchParams.get('auditId'));

  const accordionColumns = (templateName, percentageCompleted, dueDate) => [
    templateName,
    percentageCompleted + '%',
    '',
    formatDate(dueDate, DateFormatEnum.slashedddmmyy),
  ];

  const [userName, setUserName] = useState<string>('');
  const [selectorTitle, setSelectorTitle] = useState<string>();
  const [hotelList, setHotelList] = useState<IListSelector[]>([]);
  const [selectorSubTitle, setSelectorSubTitle] = useState<string>();
  const [hasMoreAuditList, setHasMoreAuditList] = useState<boolean>(true); // change the label to something specific
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedAudit, setSelectedAudit] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [myAuditList, setMyAuditList] = useState<IMyAuditList[]>([]);
  const [page, setPage] = useState<number>(1);
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const [isBottomSheetOpen, setBottomSheetOpen] = useState<boolean>(false);
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [sortingState, setSortingState] = useState<Filter[]>();
  const [currentlySortedState, setCurrentlySortedState] =
    useState<string>('-myAuditId');
  const [status, setStatus] = useState<string>('');
  const [filterType, setFilterType] = useState<
    Nullable<FilterTypesParams> | string
  >(listType);
  const [titleType, setTitleType] = useState<
    Nullable<FilterTypesParams> | string
  >(listType);
  const [templateSearchValue, setTemplateSearchValue] = useState<
    ISelectedOption[]
  >([]);
  const [containsUserSearchValue, setContainsUserSearchValue] = useState<
    IContainsSelectedOption | undefined
  >(undefined);
  const [appliedFilterCount, setAppliedFilterCount] = useState<number>(0);
  const hotelId = parseInt(searchParams.get('hotelId') as string);
  const hasHotelId: boolean = !!hotelId;
  const { selectedHotel } = userHotelDetails();
  const allHotels = getBrandAndHotelData();
  const [showSwitchHotelModal, setShowSwitchHotelModal] = useState<boolean>(
    hasHotelId && hotelId !== selectedHotel
  );
  const [notificationHotelData, setNotificationHotelData] =
    useState<INotificationHotelData>();
  const type = 'myAudit';

  async function switchHotelHandler (hotelId) {
    const hotelDetails = allHotels.find(
      (hotel) => parseInt(hotel.id) === parseInt(hotelId)
    );
    const selectedBrand = hotelDetails.brandId;
    setItem('selectedBrand', selectedBrand);
    setItem('selectedClient', hotelDetails.clientId);
    setItem('selectedHotel', hotelDetails.id);
    SetDefaultTemplateId(hotelDetails.id);
    setShowSwitchHotelModal(false);
  }

  const isViewer =
    user && user.userType === UserTypeEnum.noData;

  useEffect(() => {
    if (hotelId) {
      const SwitchHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === hotelId
      );
      const CurrentHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === parseInt(selectedHotel)
      );
      setNotificationHotelData({
        switchHotel: SwitchHotelDetail.name,
        currentHotel: CurrentHotelDetail.name,
        hotelId,
        type,
      });
    }
  }, []);

  function updateFilterCounter () {
    let count = 0;
    if (templateSearchValue.length > 0) {
      count++;
    }
    if (containsUserSearchValue && containsUserSearchValue.list.length > 0) {
      count++;
    }
    if (startDate) {
      count++;
    }
    if (status) {
      count++;
    }
    setAppliedFilterCount(count);
  }

  const statusOptions: IDropdownOption[] = [
    {
      value: 'notStarted',
      label: t('COMMON.MY_AUDIT.STATUSES.NOT_STARTED'),
    },
    {
      value: 'started',
      label: t('COMMON.MY_AUDIT.STATUSES.STARTED'),
    },
    {
      value: 'overdue',
      label: t('COMMON.MY_AUDIT.STATUSES.OVERDUE'),
    },
    {
      value: 'submitted',
      label: t('COMMON.MY_AUDIT.STATUSES.SUBMITTED'),
    },
  ];

  useEffect(() => {
    const allHotels = getBrandAndHotelData();
    const { hotelName, brandName, hotelsWithSelection } =
      getInitialHotelSelectionData(allHotels);

    setHotelList(hotelsWithSelection);
    setSelectorTitle(brandName);
    setSelectorSubTitle(hotelName);
  }, []);

  function sortingCallback (id: number | string, filters?: Filter[]) {
    const updatedFilters: Filter[] = [];
    let sortField = '';
    let sortDirection = '';
    setIsLoading(true);

    if (filters) {
      filters.forEach((filter) => {
        if (filter.id === id) {
          filter.sortingDirection =
            filter.sortingDirection === 'asc' ? 'desc' : 'asc';
          sortField = filter.field;
          sortDirection = filter.sortingDirection === 'asc' ? '' : '-';
        } else {
          filter.sortingDirection = '';
        }
        updatedFilters.push(filter);
      });
    }
    setMyAuditList([]);
    setSortingState(updatedFilters);
    setCurrentlySortedState(`${sortDirection}${sortField}`);
  }

  useEffect(() => {
    const myAuditListPayload: IGetMyAuditList = {
      page: 1,
      multiUserLookupType: filteredTypes[filterType as FilterTypesParams],
      sort: currentlySortedState,
      ...(location.state && location.state.OverDue
        ? { status: 'overdue' }
        : { status }),
      templateId:
        templateSearchValue.length > 0 ? templateSearchValue[0].id : null,
      startDate,
      endDate,
      myAuditId,
    };
    fetchMyAuditList(myAuditListPayload);
  }, [hotelList, sortingState]);

  const toggleDeleteOverlay = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const fetchMyAuditList = (payload: IGetMyAuditList) => {
    setIsLoading(true);
    if (payload.page === 1 && page > 1) {
      setPage(() => 1);
    }
    getMyAuditList(payload)
      .then((response) => {
        const results: IMyAuditList[] = response.data.results;
        if (results) {
          const { numberOfPages } = response.data;
          if (payload.page === 1) {
            setMyAuditList(results);
          } else {
            setMyAuditList([...myAuditList, ...results]);
          }
          if (payload.page >= numberOfPages) {
            setHasMoreAuditList(false);
          } else {
            setHasMoreAuditList(true);
            setPage(payload.page + 1);
          }
        } else {
          setMyAuditList([]);
          setHasMoreAuditList(false);
        }
      })
      .catch(() => {
        showErrorMessage(t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_LIST'));
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const deleteMyAudit = (id: number) => {
    setIsLoading(true);
    setMyAuditId(null);
    deleteMyAuditRequest(id)
      .then((response) => {
        const myAuditListPayload: IGetMyAuditList = {
          page: 1,
          multiUserLookupType: filteredTypes[filterType as FilterTypesParams],
          sort: currentlySortedState,
          templateId:
            templateSearchValue.length > 0 ? templateSearchValue[0].id : null,
        };
        if (response) {
          setMyAuditList([]);
          setIsLoading(false);
          fetchMyAuditList(myAuditListPayload);
          setShowDeleteModal(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
        showErrorMessage(t('COMMON.ALERT_MESSAGES.UNABLE_TO_DELETE'));
      });
  };

  useEffect(() => {
    const sortingData: Filter[] = [
      {
        label: t('COMMON.MY_AUDIT.SUMMARY_CARD.CHECKLIST'),
        field: 'templateName',
        sortingDirection: 'asc',
        id: 1,
        callback: sortingCallback,
      },
      {
        label: t('COMMON.MY_AUDIT.SUMMARY_CARD.COMPLETE'),
        field: 'percentageCompleted',
        sortingDirection: '',
        id: 2,
        callback: sortingCallback,
      },
      {
        label: t('COMMON.MY_AUDIT.SUMMARY_CARD.DUE_DATE'),
        field: 'dueDate',
        sortingDirection: '',
        id: 3,
        callback: sortingCallback,
      },
    ];
    setSortingState(sortingData);
  }, []);

  useEffect(() => {
    if (location.state && location.state.OverDue) {
      setStatus('overdue');
    }
    const myAuditListPayload: IGetMyAuditList = {
      page: 1,
      multiUserLookupType: filteredTypes[filterType as FilterTypesParams],
      sort: currentlySortedState,
      ...(location.state && location.state.OverDue
        ? { status: 'overdue' }
        : { status }),
      templateId:
        templateSearchValue.length > 0 ? templateSearchValue[0].id : null,
      startDate,
      endDate,
      myAuditId,
    };

    if (containsUserSearchValue) {
      myAuditListPayload.multiUserLookupIds = containsUserSearchValue.list;
      myAuditListPayload.multiUserLookupLogic = containsUserSearchValue.logic;
    }

    if (startDate && endDate) {
      myAuditListPayload.startDate = moment(startDate).format(
        'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
      );
      myAuditListPayload.endDate = moment(endDate)
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }
  }, [currentlySortedState, location.state]);

  useEffect(() => {
    if (isBottomSheetOpen) {
      setUserName(`${user.userFirstName} ${user.userLastName}`);
    }
  }, [isBottomSheetOpen]);

  useEffect(() => { }, [searchParams]);

  const myAuditSections = (myAuditSection) => {
    const auditSections: string[] = [];
    myAuditSection.forEach((auditSection: any) => {
      if (auditSection && auditSection.sectionName) {
        auditSections.push(auditSection.sectionName);
      }
    });
    return auditSections;
  };

  function clickHotelSelection (
    id: string | number,
    clientId: string | number,
    brandId: string | number
  ) {
    const { updatedHotelList, selectedHotel } = updateHotelSelection(
      hotelList,
      id,
      clientId,
      brandId
    );

    if (selectedHotel) {
      setMyAuditList([]);
      setPage(1);
      setSelectorTitle(selectedHotel.brandName);
      setSelectorSubTitle(selectedHotel.name);
    }

    setHotelList(updatedHotelList);
  }

  const handleFilter = () => {
    setMyAuditId(null);
    if ((startDate || endDate) && !(startDate && endDate)) {
      showErrorMessage(
        t('COMMON.ALERT_MESSAGES.PLEASE_SELECT_VALID_DATE_RANGE')
      );
      return;
    }
    updateFilterCounter();
    const myAuditListPayload: IGetMyAuditList = {
      page: 1,
      multiUserLookupType: filteredTypes[filterType as FilterTypesParams],
      multiUserLookupIds:
        containsUserSearchValue && containsUserSearchValue.list,
      multiUserLookupLogic:
        containsUserSearchValue && containsUserSearchValue.logic,
      sort: currentlySortedState,
      status,
      templateId:
        templateSearchValue.length > 0 ? templateSearchValue[0].id : null,
    };

    if (startDate && endDate) {
      myAuditListPayload.startDate = moment(startDate).format(
        'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
      );
      myAuditListPayload.endDate = moment(endDate)
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    setBottomSheetOpen(false);
    setMyAuditList([]);
    setIsLoading(true);
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (filterType != null && filterType !== '') {
        next.set('filterBy', filterType);
      } else {
        next.delete('filterBy');
      }
      return next;
    });
    setTitleType(filterType);
    fetchMyAuditList(myAuditListPayload);
    return;
  };

  function handleContainsUsersSeachValue (
    selectedOptions: IContainsSelectedOption
  ) {
    setContainsUserSearchValue(selectedOptions);
  }

  function handleTemplateSeachValue (selectedOptions: ISelectedOption[]) {
    setTemplateSearchValue(selectedOptions);
  }

  function clearFilters () {
    updateFilterCounter();
    setFilterType(titleType);
    setClearFilter(!clearFilter);
    setContainsUserSearchValue(undefined);
    setTemplateSearchValue([]);
    setStartDate(undefined);
    setEndDate(undefined);
    setStatus('');
    setAppliedFilterCount(0);
    setBottomSheetOpen(false);
    const myAuditListPayload = {
      page: 1,
      multiUserLookupType: filteredTypes[titleType as FilterTypesParams],
      multiUserLookupIds: [],
      multiUserLookupLogic: null,
      sort: currentlySortedState,
      status: '',
      startDate: undefined,
      endDate: undefined,
      templateId: null,
    };

    fetchMyAuditList(myAuditListPayload);
  }

  const disableCompleteButton = (audit: IMyAuditList) => {
    const auditorsMap = audit.auditors.map((auditor) => auditor.auditorId);
    const userNotIncluded = !auditorsMap.includes(user.id);
    return audit.isSubmitted || userNotIncluded;
  };

  return (
    <>
      <HeaderContainer data-testid="my-audit-list-header">
        <AppHeader title={t('COMMON.MY_AUDIT.TITLE')} />
        <>
          <LineHeader />
          <SubHeaderSelector
            title={selectorTitle}
            subTitle={selectorSubTitle}
            listSelector={hotelList}
            clickSelectSection={clickHotelSelection}
          />
        </>
      </HeaderContainer>
      <StyledMyAuditContainer>
        <MyAuditListContainer>
          <DepartmentHeaderContainer>
            <Headline3 data-testid="my-audit-list-title">
              {titleType === 'sent'
                ? t('COMMON.MY_AUDIT.TITLES.CREATED_MY_AUDITS')
                : t('COMMON.MY_AUDIT.TITLES.RECEIVED_MY_AUDITS')}
            </Headline3>
            <FilterContainer>
              <IconButton
                title={`${t('COMMON.MY_AUDIT.BUTTON.FILTER')} ${appliedFilterCount > 0 ? ` (${appliedFilterCount})` : ''}`}
                onClick={() => setBottomSheetOpen(true)}
                rightIcon={<FilterIcon />}
                data-testid="my-audit-list-button-filter"
              />
            </FilterContainer>
          </DepartmentHeaderContainer>
          {myAuditList.length > 0 && (
            <Sort
              filters={sortingState}
              data-testid="my-audit-list-sort-button"
            />
          )}
          <ContentContainer>
            <InfiniteScroll
              dataLength={myAuditList.length}
              next={() => {
                const payload: IGetMyAuditList = {
                  page,
                  multiUserLookupType:
                    filteredTypes[filterType as FilterTypesParams],
                  sort: currentlySortedState,
                  status,
                  startDate,
                  endDate,
                  templateId:
                    templateSearchValue.length > 0
                      ? templateSearchValue[0].id
                      : null,
                };
                if (startDate && endDate) {
                  payload.startDate = moment(startDate).format(
                    'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
                  );
                  payload.endDate = moment(endDate)
                    .endOf('day')
                    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
                }
                if (containsUserSearchValue) {
                  payload.multiUserLookupIds = containsUserSearchValue.list;
                  payload.multiUserLookupLogic = containsUserSearchValue.logic;
                }
                fetchMyAuditList(payload);
              }}
              hasMore={hasMoreAuditList}
              loader={isLoading && <MyAuditSkeleton />}
            >
              {myAuditList.length > 0
                ? myAuditList.map((audit, index) => {
                  return (
                    <ExpandableCard
                      columns={accordionColumns(
                        audit.templateName,
                        audit.percentageCompleted,
                        audit.dueDate
                      )}
                      subject={audit.subject}
                      key={`auditId-${audit.myAuditId}-index-${index}`}
                    >
                      <CardContentWrapper>
                        <AuditorContainer>
                          {audit.auditors.map((auditor) => {
                            return (
                              <ContentContainer key={auditor.auditorId}>
                                <AuditorContent data-testid="my-audit-list-expandable-card-auditor-name">
                                  {auditor.auditorName}:
                                </AuditorContent>{' '}
                                <AuditorSectionContainer data-testid="my-audit-list-expandable-card-sections">
                                  {myAuditSections(auditor.sections).join(
                                    ', '
                                  )}
                                </AuditorSectionContainer>
                              </ContentContainer>
                            );
                          })}
                        </AuditorContainer>
                        <ButtonContainer>
                          <Button
                            outlined={true}
                            inverted={true}
                            title={t('COMMON.MY_AUDIT.BUTTON.VIEW')}
                            backgroundColor={'oxfordBlue'}
                            onClick={() =>
                              navigate(
                                `/myaudit/details?auditId=${audit.myAuditId}`
                              )
                            }
                            disabled={!audit.isSubmitted}
                            data-testid="my-audit-list-expandable-card-view-button"
                          />
                          <Button
                            title={t('COMMON.MY_AUDIT.BUTTON.SUMMARY')}
                            onClick={() =>
                              navigate(
                                `/myaudit/summary/?auditId=${audit.myAuditId}`
                              )
                            }
                            disabled={!audit.isSubmitted}
                            data-testid="my-audit-list-expandable-card-summary-button"
                          />
                          <Button
                            title={t('COMMON.MY_AUDIT.BUTTON.COMPLETE')}
                            backgroundColor={'verdigris'}
                            onClick={() =>
                              navigate(
                                `/myaudit/conduct?auditId=${audit.myAuditId}`
                              )
                            }
                            disabled={disableCompleteButton(audit)}
                            data-testid="my-audit-list-expandable-card-complete-button"
                          />

                          <Button
                            title={t('COMMON.MY_AUDIT.BUTTON.DELETE')}
                            backgroundColor={'rustyRed'}
                            onClick={() => {
                              setShowDeleteModal(true);
                              setSelectedAudit(audit.myAuditId);
                            }}
                            disabled={
                              audit.isSubmitted || audit.creatorId !== user.id
                            }
                            data-testid="my-audit-list-expandable-card-delete-button"
                          />
                        </ButtonContainer>
                      </CardContentWrapper>
                    </ExpandableCard>
                  );
                })
                : isLoading && <MyAuditSkeleton />}
            </InfiniteScroll>
            {!isLoading && myAuditList.length === 0 && (
              <NoResultContainer data-testid="my-audit-list-no-results">
                <SearchFile />
                <Body3
                  color="eerieBlack"
                  data-testid="my-audit-list-no-results-title"
                >
                  {t('COMMON.MY_AUDIT.LIST.NO_DATA.TITLE')}
                </Body3>
                <NoDataMessageContainer data-testid="my-audit-list-no-results-message">
                  <Body4 color="eerieBlack">
                    {t('COMMON.MY_AUDIT.LIST.NO_DATA.MESSAGE')}
                  </Body4>
                </NoDataMessageContainer>
                {!isViewer && (
                  <CreateNewMyAuditButtonContainer>
                    <ButtonLarge
                      title={t(
                        'COMMON.MY_ACTIONS.BOTTOM_SHEET.BUTTONS.CREATE_MY_AUDIT'
                      )}
                      onClick={() => {
                        removeItem('myAudit');
                        removeItem('editCard');
                        navigate('/myaudit/checklist');
                      }}
                    />
                  </CreateNewMyAuditButtonContainer>
                )}
              </NoResultContainer>
            )}
          </ContentContainer>
        </MyAuditListContainer>
      </StyledMyAuditContainer>
      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          handleModalClose={toggleDeleteOverlay}
          data-testid="my-audit-list-delete-modal"
        >
          <ButtonBlockColumn>
            <DeleteTitleContainer>
              <Headline3 data-testid="my-audit-list-delete-modal-confirmation-text">
                {t('COMMON.MY_AUDIT.DETAILS.DELETE_CONFIRMATION')}
              </Headline3>
            </DeleteTitleContainer>
            <ButtonLarge
              title={t('COMMON.BOTTOM_SHEET.DELETE')}
              onClick={() => deleteMyAudit(selectedAudit)}
              disabled={isLoading}
              backgroundColor="rustyRed"
              data-testid="my-audit-list-delete-modal-delete-button"
            />
            <ButtonLarge
              title={t('COMMON.BOTTOM_SHEET.CANCEL')}
              onClick={() => setShowDeleteModal(false)}
              outlined={true}
              inverted={true}
              data-testid="my-audit-list-delete-modal-cancel-button"
            />
          </ButtonBlockColumn>
        </Modal>
      )}
      <BottomSheet
        isOpen={isBottomSheetOpen}
        onClose={() => {
          setBottomSheetOpen(false);
        }}
        title={t('COMMON.MY_AUDIT.BUTTON.FILTER')}
        data-testid="my-audit-list-bottom-sheet"
      >
        <FiltersContent>
          <FilterModalHeaderContainer>
            <StatusRadioReceivedWrapper checked={filterType === 'received'}>
              <RadioButton
                data-testid="my-audit-list-bottom-sheet-radio-button-received"
                checked={filterType === 'received'}
                label={t('COMMON.MY_ACTIONS.SELECTOR.RECEIVED')}
                onClick={() => {
                  setFilterType('received');
                }}
              />
            </StatusRadioReceivedWrapper>
            <StatusRadioCreatedByWrapper checked={filterType === 'sent'}>
              <RadioButton
                data-testid="my-audit-list-bottom-sheet-radio-button-sent"
                checked={filterType === 'sent'}
                label={t('COMMON.MY_ACTIONS.SELECTOR.CREATED_BY')}
                onClick={() => {
                  setFilterType('sent');
                }}
              />
            </StatusRadioCreatedByWrapper>
            <StatusRadioAssessedWrapper
              checked={filterType === filteredTypes.tagged}
            >
              {hasTagged && (
                <RadioButton
                  data-testid="my-audit-list-bottom-sheet-radio-button-tagged"
                  checked={filterType === filteredTypes.tagged}
                  label={t('COMMON.MY_ACTIONS.SELECTOR.TAGGED')}
                  onClick={() => {
                    setFilterType(filteredTypes.tagged);
                  }}
                />
              )}
            </StatusRadioAssessedWrapper>
          </FilterModalHeaderContainer>
          <PaddingBottomM>
            <DisabledSearchBoxContainer>
              <IconContainer>
                <SearchIcon data-testid="my-audit-list-bottom-sheet-search-icon" />
              </IconContainer>
              <SearchFieldInput
                data-testid="my-audit-list-bottom-sheet-user-name"
                disabled={true}
                type="text"
                value={userName}
              />
            </DisabledSearchBoxContainer>
          </PaddingBottomM>
          <PaddingBottomM>
            <SearchBoxContainsUsers
              callBackSelectedOptions={handleContainsUsersSeachValue}
              clearFilter={clearFilter}
              loggedUser={user}
            />
          </PaddingBottomM>
          <PaddingBottomM>
            <SearchBoxTemplate
              callBackSelectedOptions={handleTemplateSeachValue}
              clearFilter={clearFilter}
            />
          </PaddingBottomM>
          <PaddingBottomM>
            <PaddingBottomS>
              <Body5
                color="eerieBlack"
                data-testid="my-audit-list-bottom-sheet-date-range-title"
              >
                {t('COMMON.MY_AUDIT.TITLES.DATE_RANGE')}
              </Body5>
            </PaddingBottomS>
            <MyAuditDatePickerContainer>
              <InputContainer>
                <DatePickerWrapper>
                  <DatePicker
                    className={`myaudit-filter-date-picker`}
                    popperClassName="date-picker-popper"
                    dateFormat="dd-MM-yyyy"
                    onFocus={(e) => e.target.blur()}
                    placeholderText="Start Date"
                    selected={startDate}
                    onChange={(selectedDate) => {
                      if (selectedDate) {
                        setStartDate(selectedDate);
                      }
                    }}
                    maxDate={endDate}
                    data-testid="my-audit-list-bottom-sheet-date-picker-start-date"
                  />
                </DatePickerWrapper>
                <CalendarIconContainer>
                  {startDate ? (
                    <CloseCircleDark
                      data-testid="my-audit-list-bottom-sheet-date-picker-start-date-clear"
                      onClick={() => setStartDate(undefined)}
                    />
                  ) : (
                    <Calendar data-testid="my-audit-list-bottom-sheet-date-picker-start-date-calendar" />
                  )}
                </CalendarIconContainer>
              </InputContainer>
              <InputContainer>
                <DatePickerWrapper>
                  <DatePicker
                    className={`myaudit-filter-date-picker`}
                    popperClassName="date-picker-popper"
                    dateFormat="dd-MM-yyyy"
                    minDate={startDate}
                    onFocus={(e) => e.target.blur()}
                    placeholderText="End Date"
                    selected={endDate}
                    onChange={(selectedDate) => {
                      if (selectedDate) {
                        setEndDate(selectedDate);
                      }
                    }}
                    data-testid="my-audit-list-bottom-sheet-date-picker-end-date"
                  />
                </DatePickerWrapper>
                <CalendarIconContainer>
                  {endDate ? (
                    <CloseCircleDark
                      data-testid="my-audit-list-bottom-sheet-date-picker-end-date-clear"
                      onClick={() => setEndDate(undefined)}
                    />
                  ) : (
                    <Calendar data-testid="my-audit-list-bottom-sheet-date-picker-end-date-calendar" />
                  )}
                </CalendarIconContainer>
              </InputContainer>
            </MyAuditDatePickerContainer>
          </PaddingBottomM>
          <PaddingBottomS>
            <Body5
              data-testid="my-audit-list-bottom-sheet-status-title"
              color="eerieBlack"
            >
              {t('COMMON.MY_AUDIT.TITLES.STATUS')}
            </Body5>
          </PaddingBottomS>
          <PaddingBottomL>
            {status !== '' ? (
              <DropdownSingle
                options={statusOptions}
                defaultOption={statusOptions.find(
                  (option) => option.value === status
                )}
                menuPlacement="top"
                callback={(event) => {
                  setStatus(event.value);
                }}
              />
            ) : (
              <DropdownSingle
                defaultOption={null}
                options={statusOptions}
                menuPlacement="top"
                callback={(event) => {
                  setStatus(event.value);
                }}
              />
            )}
          </PaddingBottomL>
          <BottomSheetButtonSpacing>
            <ButtonLarge
              title={t('COMMON.MY_AUDIT.BUTTON.SHOW_RESULTS')}
              onClick={() => {
                handleFilter();
              }}
              data-testid="my-audit-list-bottom-sheet-show-results-button"
            />
            <ButtonLarge
              outlined={true}
              inverted={true}
              backgroundColor={'eerieBlack'}
              title={t('COMMON.MY_AUDIT.BUTTON.CLEAR_FILTERS')}
              onClick={() => clearFilters()}
              data-testid="my-audit-list-bottom-sheet-show-clear-filters-button"
            />
          </BottomSheetButtonSpacing>
        </FiltersContent>
      </BottomSheet>
      {showSwitchHotelModal && notificationHotelData && (
        <SwitchHotelModal
          showSwitchHotelModal={showSwitchHotelModal}
          handleModalClose={() => setShowSwitchHotelModal(false)}
          switchHotelHandler={switchHotelHandler}
          notificationHotelData={notificationHotelData}
        />
      )}
    </>
  );
}
